import { AlertTriangle } from 'lucide-react';

import { cn } from '@core/utils/cn';

import { Button } from './Button';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  /** Surfaced for support. Comes from the backend's RFC 9457 ProblemDetail. */
  traceId?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({
  title = 'Something went wrong',
  message,
  traceId,
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn('flex flex-col items-center justify-center px-6 py-16 text-center', className)}
    >
      <AlertTriangle className="text-danger mb-4 size-9" aria-hidden />
      <p className="text-[17px] font-semibold tracking-[-0.01em]">{title}</p>
      {message && <p className="text-fg-muted mt-1.5 max-w-sm text-[15px]">{message}</p>}
      {onRetry && (
        <Button variant="secondary" className="mt-5" onClick={onRetry}>
          Try again
        </Button>
      )}
      {traceId && (
        <p className="tnum text-fg-subtle mt-4 text-[11px]">
          Reference <span className="font-medium">{traceId}</span>
        </p>
      )}
    </div>
  );
}
